<dx-scroll-view>
  <dx-data-grid
    id="route-details"
    class="route-details"
    [dataSource]="ds"
    [showRowLines]="true"
    [rowAlternationEnabled]="false"
    [hoverStateEnabled]="true"
    [columnAutoWidth]="true"
    (onSelectionChanged)="historyPathDetailsClicked($event)"
    [showBorders]="false">
    <dxo-selection mode="single"></dxo-selection>
    <dxi-column
      caption=""
      dataField="icon"
      width="34"
      cellTemplate="routeSequenceIconTemplate">
    </dxi-column>

    <dxi-column
      caption="Temps"
      dataType="date"
      format="shortDateShortTime"
      width="45%"
      dataField="time">
    </dxi-column>

    <dxi-column
      caption="Information"
      dataField="information">
    </dxi-column>

    <div *dxTemplate="let data of 'routeSequenceIconTemplate'">
      <img [src]="data.value"/>
    </div>

    <div *dxTemplate="let tag of 'routeTagDetailsTemplate'">
      <div>Détails</div>
    </div>
  </dx-data-grid>
</dx-scroll-view>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.05)"
  [position]="{of: host.nativeElement}"
  [visible]="isLoading"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
